import { AgingTable } from "@/components/accounting/aging-table";
import { useBreadcrumbs } from "@/lib/use-breadcrumbs";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/accounting/receivables")({
	component: ReceivablesPage,
});

function ReceivablesPage() {
	const { t } = useTranslation("accounting");
	useBreadcrumbs([{ label: t("nav_receivables") }]);
	return <AgingTable accountPrefix="62" titleKey="ar_aging_title" />;
}
